import {
  ServerTable,
  ClientTable,
} from 'vue-tables-2';

export default ({ Vue }) => {
  Vue.use(ServerTable);
  Vue.use(ClientTable);
};



// WEBPACK FOOTER //
// ./src/plugins/vue-tables-2.js